'use client'

import { useResponsive } from '@/hooks/useResponsive'

export type ResponsiveSlot = 'desktop' | 'mobile'

export default function useActiveResponsiveSlot(slot: ResponsiveSlot) {
  const responsive = useResponsive()

  if (!responsive) return false

  return slot === 'desktop' ? Boolean(responsive.md) : !responsive.md
}
